(function () {
  function openDialog(dialog) {
    if (!dialog) return;
    if (typeof dialog.showModal === "function") dialog.showModal();
    else dialog.setAttribute("open", "open");
  }

  function closeDialog(dialog) {
    if (!dialog) return;
    if (typeof dialog.close === "function") dialog.close();
    else dialog.removeAttribute("open");
  }

  document.addEventListener("click", function (e) {
    const openBtn = e.target.closest("[data-peragon-modal-open]");
    if (openBtn) {
      const id = openBtn.getAttribute("data-peragon-modal-open");
      const dialog = document.getElementById(id);
      openDialog(dialog);
      return;
    }

    const closeBtn = e.target.closest("[data-peragon-modal-close]");
    if (closeBtn) {
      const dialog = closeBtn.closest("dialog");
      closeDialog(dialog);
      return;
    }
  });

  // Close on backdrop click
  document.addEventListener("click", function (e) {
    const dialog = e.target instanceof HTMLDialogElement ? e.target : null;
    if (!dialog) return;

    const rect = dialog.getBoundingClientRect();
    const inDialog =
      e.clientX >= rect.left &&
      e.clientX <= rect.right &&
      e.clientY >= rect.top &&
      e.clientY <= rect.bottom;

    if (!inDialog) closeDialog(dialog);
  });
})();
